/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_No_Profile_MessageInputs */



/**
* | output |
* | --- |
* | "No profile or file extension provided." |
*
* @param {Iframe_Remote_Subtitle_No_Profile_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_no_profile_message = /** @type {((inputs?: Iframe_Remote_Subtitle_No_Profile_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_No_Profile_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun profil ou extension de fichier fourni.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurde kein Profil oder keine Dateierweiterung angegeben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun profilo o estensione di file forniti.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Профиль и расширение файла не указаны.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se proporcionó ningún perfil ni extensión de archivo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未提供配置文件或文件扩展名。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロファイルまたはファイル拡張子が指定されていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई प्रोफ़ाइल या फ़ाइल एक्सटेंशन प्रदान नहीं किया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum perfil ou extensão de arquivo foi fornecido.")
	return /** @type {LocalizedString} */ ("No profile or file extension provided.")
});